// ThinkStack contact numbers (single source of truth)
export const CONTACTS = {
  raman: { name: "Raman", phone: "+65 9821 2061", wa: "6598212061" },
  kriti: { name: "Kriti", phone: "+65 9005 2817", wa: "6590052817" },
};

export const waLink = (wa, text) =>
  `https://wa.me/${wa}?text=${encodeURIComponent(text || "")}`;
